import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import ChatWithUs from "../../components/ChatWithUs/ChatWithUs";
import countriesData from "../../data/countries.json";
import ChinaFlag from "../../assets/ChinaFlag.jpg";
import "./China.css";

const China = () => {
  const navigate = useNavigate();

  const chinaCategories =
    countriesData.find((country) => country.country === "China")?.categories ||
    [];

  const handleClick = (category) => {
    navigate("/products", {
      state: { country: "China", category: category.name },
    });
  };

  return (
    <>
      <Navbar />
      <div className="china-container">
        <div
          className="china-banner"
          style={{ backgroundImage: `url(${ChinaFlag})` }}
        >
          <h1>Products from China</h1>
        </div>

        <div className="china-products">
          {chinaCategories.map((cat, idx) => (
            <div
              key={idx}
              className="china-product-card"
              onClick={() => handleClick(cat)}
            >
              <img src={cat.Image} alt={cat.name} />
              <p>{cat.name}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
      <ChatWithUs />
    </>
  );
};

export default China;
